import { useEffect, useState } from 'react';
import { Events as EventsApi } from '../lib/api';
import type { SystemEvent } from '@freebuff/shared';
import { Pill, Spinner, EmptyState } from '../components/Common';

export function Events() {
  const [events, setEvents] = useState<SystemEvent[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    EventsApi.list({ limit: 200 }).then((r) => setEvents(r.events)).finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner />;

  return (
    <div className="card">
      <div className="card-header">
        <div>
          <h2 className="text-lg font-semibold">Eventos do sistema</h2>
          <p className="text-xs text-slate-400">Registro de ações relevantes (criação de agente, alertas, etc).</p>
        </div>
      </div>
      <div className="card-body">
        {events.length === 0 ? <EmptyState title="Nenhum evento registrado" /> : (
          <div className="overflow-x-auto -mx-5">
            <table className="table">
              <thead><tr><th>Quando</th><th>Tipo</th><th>Severidade</th><th>Mensagem</th></tr></thead>
              <tbody>
                {events.map((e: SystemEvent) => (
                  <tr key={e.id}>
                    <td className="text-xs text-slate-400 whitespace-nowrap">{new Date(e.ts).toLocaleString('pt-BR')}</td>
                    <td className="font-mono text-xs">{e.type}</td>
                    <td>
                      <Pill tone={e.severity === 'error' ? 'error' : e.severity === 'warn' ? 'warn' : e.severity === 'ok' ? 'ok' : 'info'}>
                        {e.severity}
                      </Pill>
                    </td>
                    <td>{e.message}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
